<h2 mat-dialog-title>Enter Project Details</h2>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-dialog-content>
        <div class="form-field">

            <!-- Package Split Button -->
            <div class="split-button" style="margin-bottom: 16px;">
                <button mat-raised-button color="accent" (click)="onPackageSelect(this.data)">
                    {{ this.data?.package_name || 'Select Package' }}
                </button>
                <button mat-icon-button [matMenuTriggerFor]="packageMenu">
                    <mat-icon>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #packageMenu="matMenu">
                    <ng-container *ngFor="let pkg of packages">
                        <button mat-menu-item (click)="onPackageSelect(pkg)">
                            {{ pkg.package_name }}
                        </button>
                    </ng-container>
                </mat-menu>
            </div>

            <!-- Land Size + Unit -->
            <div style="display: flex; gap: 16px;">
                <mat-form-field appearance="fill" style="flex: 1;">
                    <mat-label>Land Size</mat-label>
                    <input matInput type="number" formControlName="land_size" required>
                </mat-form-field>

                <mat-form-field appearance="fill" style="flex: 1;">
                    <mat-label>Unit</mat-label>
                    <mat-select formControlName="land_unit" required>
                        <mat-option *ngFor="let unit of unitArray" [value]="unit.value">
                            {{ unit.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Built-up Area + Unit -->
            <div style="display: flex; gap: 16px;">
                <mat-form-field appearance="fill" style="flex: 1;">
                    <mat-label>Built-up Area</mat-label>
                    <input matInput type="number" formControlName="builtUpArea" required>
                </mat-form-field>

                <mat-form-field appearance="fill" style="flex: 1;">
                    <mat-label>Unit</mat-label>
                    <mat-select formControlName="builtUpAreaUnit" required>
                        <mat-option *ngFor="let unit of unitArray" [value]="unit.value">
                            {{ unit.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Construction Duration -->
            <mat-form-field appearance="fill" style="width: 100%;">
                <mat-label>Duration (months)</mat-label>
                <input matInput type="number" formControlName="duration" (input)="calculateAmount()" required>
            </mat-form-field>

            <!-- Users -->
            <mat-form-field appearance="fill" style="width: 100%;">
                <mat-label>Users</mat-label>
                <input matInput type="number" formControlName="users" (input)="calculateAmount()" required>
            </mat-form-field>

            <!-- Total Amount -->
            <div class="col-span-6" style="margin-top: 12px;">
                <mat-label>Total Amount</mat-label>
                <div><strong>{{ totalPayAmount | currency }}</strong></div>
            </div>

        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Submit</button>
    </mat-dialog-actions>
</form>